import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../types'

const selectAdminState = (state: RootState) => state.admin

/**
 * Selector para obter contagem de pedidos pendentes
 */
export const selectPendingOrdersCount = createSelector(
  [selectAdminState],
  (admin) => admin.pendingOrdersCount
)

/**
 * Selector para verificar se está carregando contagem de pedidos pendentes
 */
export const selectIsLoadingPendingCount = createSelector(
  [selectAdminState],
  (admin) => admin.isLoadingPendingCount
)

/**
 * Selector para obter erro ao carregar contagem de pedidos pendentes
 */
export const selectPendingCountError = createSelector(
  [selectAdminState],
  (admin) => admin.pendingCountError
)

/**
 * Selector para obter stats do dashboard
 */
export const selectDashboardStats = createSelector(
  [selectAdminState],
  (admin) => admin.dashboardStats
)

